import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";

import type { AppointmentV2 } from "api/services/appointment/schemas/appointment_v2";
import { useApiClient } from "api/useApiClient";

export const getAppointmentsV2PatientQueryKeyPrefix = "getPatientAppointments";
type QueryKey = [typeof getAppointmentsV2PatientQueryKeyPrefix, number, number];
const getAppointmentsV2PatientQueryKey = (userId: number, patientId: number): QueryKey => [
  getAppointmentsV2PatientQueryKeyPrefix,
  userId,
  patientId,
];

export const useGetAppointmentsV2Patient = (
  userId: number,
  patientId: number,
  options?: UseQueryOptions<AppointmentV2[], Error, AppointmentV2[], QueryKey>
) => {
  const client = useApiClient();

  return useQuery({
    queryKey: getAppointmentsV2PatientQueryKey(userId, patientId),
    queryFn: () => client.getAppointmentsV2Patient(userId, patientId),
    ...options,
  });
};
